"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertOrdinalWordToNumber = convertOrdinalWordToNumber;
function convertOrdinalWordToNumber(word) {
    const ordinals = {
        first: "1st",
        second: "2nd",
        third: "3rd",
        fourth: "4th",
        fifth: "5th",
        sixth: "6th",
        seventh: "7th",
        eighth: "8th",
        ninth: "9th",
        tenth: "10th",
    };
    return ordinals[word.toLowerCase()] || word;
}
